import { atom } from 'jotai'

export const isPartialApproveEnabledAtom = atom<boolean>(false)
